// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.dash-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
@media screen and (max-width: 991px) {
  .dash-grid {
    grid-template-columns: 1fr;
  }
}
.dash-grid > [class*=f-col-] {
  width: 100%;
  padding-inline: 0;
}
.dash-grid .f-col-12,
.dash-grid .dash-banner {
  grid-column: 1/-1;
}

.dash-left-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dash-lm-cell {
  overflow: hidden;
}
.dash-lm-cell .dash-card--learnermap {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.dash-lm-cell .dash-card--learnermap .dash-card__lm-image {
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
}

.dash-greeting {
  font-family: "Museo-700";
  font-size: 26px;
  margin-bottom: 2px;
}

.dash-subtitle {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #676a6c;
  margin: 0;
}

.dash-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #eef0f2;
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.dash-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.dash-card--profile {
  border-top: 4px solid #ccc;
  text-align: center;
}
.dash-card--profile.dash-card--profile-clarifier {
  border-top-color: rgb(0, 173, 208);
}
.dash-card--profile.dash-card--profile-ideator {
  border-top-color: rgb(255, 121, 0);
}
.dash-card--profile.dash-card--profile-developer {
  border-top-color: rgb(105, 190, 40);
}
.dash-card--profile.dash-card--profile-implementer {
  border-top-color: rgb(245, 67, 89);
}
.dash-card--profile.dash-card--profile-earlybird {
  border-top-color: rgb(0, 173, 208);
}
.dash-card--profile.dash-card--profile-analyst {
  border-top-color: rgb(105, 190, 40);
}
.dash-card--profile.dash-card--profile-driver {
  border-top-color: rgb(245, 67, 89);
}
.dash-card--profile.dash-card--profile-finisher {
  border-top-color: rgb(245, 67, 89);
}
.dash-card--profile.dash-card--profile-ideator-clarifier, .dash-card--profile.dash-card--profile-clarifier-ideator {
  border-top-color: rgb(255, 121, 0);
}
.dash-card--profile.dash-card--profile-developer-implementer, .dash-card--profile.dash-card--profile-implementer-developer {
  border-top-color: rgb(105, 190, 40);
}
.dash-card--profile.dash-card--profile-integrator {
  border-top-color: #a7a7a7;
}
.dash-card--profile .dash-card__profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 24px 16px;
}
.dash-card--profile .dash-card__profile-avatar {
  flex-shrink: 0;
}
.dash-card--profile .dash-card__profile-avatar a {
  display: block;
  cursor: pointer;
}
.dash-card--profile .dash-card__profile-avatar ::ng-deep .profile-centered {
  width: 72px;
  height: 72px;
}
.dash-card--profile .dash-card__profile-info {
  min-width: 0;
}
.dash-card--profile .dash-card__profile-name {
  font-family: "Museo-700";
  font-size: 20px;
  margin: 0 0 4px;
}
.dash-card--profile .dash-card__profile-title {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #676a6c;
  display: block;
}
.dash-card--profile .dash-card__profile-body {
  padding: 0 24px 16px;
}
.dash-card--profile .dash-card__profile-body p {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #676a6c;
  line-height: 1.6;
  margin: 0;
}
.dash-card--profile .dash-card__profile-footer {
  padding: 0 24px 24px;
}
.dash-card--profile .dash-card__view-link {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #676a6c;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}
.dash-card--profile .dash-card__view-link i {
  margin-left: 4px;
  font-size: 11px;
}
.dash-card--profile .dash-card__view-link:hover {
  color: rgb(0, 173, 208);
}

.dash-card--branding {
  text-align: center;
}
.dash-card--branding .dash-card__branding-header {
  padding: 24px 24px 16px;
}
.dash-card--branding .dash-card__branding-header .dash-card__branding-logo {
  max-width: 200px;
  height: auto;
}
.dash-card--branding .dash-card__branding-body {
  padding: 0 24px 24px;
}
.dash-card--branding .dash-card__contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.dash-card--branding .dash-card__contact-name {
  font-family: "Museo-700";
  font-size: 16px;
  margin-bottom: 4px;
}
.dash-card--branding .dash-card__contact-profile {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eef0f2;
}
.dash-card--branding .dash-card__contact-profile span {
  font-size: 13px;
  color: #676a6c;
}
.dash-card--branding .dash-card__contact-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 13px;
  color: #676a6c;
  width: 100%;
}
.dash-card--branding .dash-card__contact-item i {
  width: 16px;
  text-align: center;
  color: #9ca3af;
  flex-shrink: 0;
}
.dash-card--branding .dash-card__contact-item a {
  color: #676a6c;
  text-decoration: none;
  word-break: break-all;
}
.dash-card--branding .dash-card__contact-item a:hover {
  color: rgb(0, 173, 208);
}

.dash-card--learnermap {
  cursor: pointer;
  overflow: hidden;
}
.dash-card--learnermap:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}
.dash-card--learnermap:hover .dash-card__lm-overlay {
  opacity: 1;
}
.dash-card--learnermap .dash-card__lm-header {
  padding: 20px 24px 12px;
}
.dash-card--learnermap .dash-card__lm-header h5 {
  font-family: "Museo-700";
  font-size: 16px;
  margin: 0;
}
.dash-card--learnermap .dash-card__lm-image {
  position: relative;
}
.dash-card--learnermap .dash-card__lm-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}
.dash-card--learnermap .dash-card__lm-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px 24px 24px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
  display: flex;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.dash-card--learnermap .dash-card__lm-overlay .f-btn--outline {
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
}

.dash-card--error {
  text-align: center;
  padding: 48px 32px;
}
.dash-card--error .dash-error-icon {
  font-size: 48px;
  color: #ff485c;
  margin-bottom: 16px;
}
.dash-card--error h2 {
  font-size: 22px;
  margin-bottom: 12px;
}
.dash-card--error p {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #676a6c;
  max-width: 480px;
  margin: 0 auto 8px;
  line-height: 1.6;
}
.dash-card--error .dash-error-hint {
  color: #9ca3af;
  font-style: italic;
}

.dash-card--empty {
  text-align: center;
  padding: 40px 32px;
}
.dash-card--empty .dash-empty-icon {
  font-size: 48px;
  color: #d1d5db;
  margin-bottom: 16px;
}
.dash-card--empty h5 {
  font-family: "Museo-700";
  font-size: 18px;
  margin-bottom: 12px;
}
.dash-card--empty p {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #676a6c;
  line-height: 1.6;
  max-width: 420px;
  margin: 0 auto 8px;
}
.dash-card--empty p a {
  color: rgb(0, 173, 208);
  text-decoration: none;
  font-weight: 600;
}
.dash-card--empty p a:hover {
  text-decoration: underline;
}

.dash-banner {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 12px;
  border: 1px solid;
}
.dash-banner--warning {
  background: #fffbeb;
  border-color: #fde68a;
}
.dash-banner--warning .dash-banner__icon {
  color: #f59e0b;
}
.dash-banner--info {
  background: #eff6ff;
  border-color: #bfdbfe;
}
.dash-banner--info .dash-banner__icon {
  color: rgb(0, 173, 208);
}
.dash-banner .dash-banner__icon {
  font-size: 22px;
  flex-shrink: 0;
  padding-top: 2px;
}
.dash-banner .dash-banner__content {
  flex: 1;
}
.dash-banner .dash-banner__content h5 {
  font-family: "Museo-700";
  font-size: 15px;
  margin: 0 0 6px;
}
.dash-banner .dash-banner__content p {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #676a6c;
  margin: 0;
  line-height: 1.5;
}
.dash-banner .dash-banner__content p a {
  color: rgb(0, 173, 208);
  text-decoration: none;
}
.dash-banner .dash-banner__content p a:hover {
  text-decoration: underline;
}
.dash-banner .dash-banner__action {
  flex-shrink: 0;
  align-self: center;
}
.dash-banner .dash-banner__action .f-btn {
  white-space: nowrap;
  cursor: pointer;
}

::ng-deep .pace-running:not(.pace-done) .dash-card__profile-name,
::ng-deep .pace-running:not(.pace-done) .dash-card__profile-title {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar 1.6s infinite linear;
  height: 20px;
  font-size: 0;
  border-radius: 4px;
}
::ng-deep .pace-running:not(.pace-done) .dash-card__branding-logo {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar 1.6s infinite linear;
  height: 100px;
  opacity: 0;
}
::ng-deep .pace-running:not(.pace-done) .dash-card__contact-list li {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar 1.6s infinite linear;
  margin: 0 0 1px 0;
  height: 19px;
  font-size: 0;
  border-radius: 4px;
}

@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 500px;
  }
}
::ng-deep .introjs-tooltip {
  box-sizing: content-box;
  visibility: visible;
  min-width: 200px;
  max-width: 300px;
  transition: opacity 0.1s ease-out;
  width: 243px;
  height: auto;
  background: #fff;
  border-radius: 100px;
  position: relative;
  margin: 90px auto 20px;
  padding: 20px !important;
  box-shadow: 0 0px !important;
}
::ng-deep .introjs-tooltip .introjs-arrow.top {
  background: url("https://assets.foursightonline.com/app/images/cloud-arrow-icon.png");
  width: 10px !important;
  height: 10px !important;
  display: block !important;
  padding: 32px;
  background-size: 100% !important;
  top: -80px;
  background-color: transparent;
  border: none;
}
::ng-deep .introjs-tooltip .introjs-arrow.left {
  background: url("https://assets.foursightonline.com/app/images/cloud-arrow-icon.png");
  width: 10px !important;
  height: 10px !important;
  display: block !important;
  padding: 32px;
  background-size: 100% !important;
  top: 90px;
  background-color: transparent;
  border: none;
  transform: rotate(-70deg);
  left: -50px;
}
::ng-deep .introjs-tooltip:after, ::ng-deep .introjs-tooltip:before {
  content: "";
  position: absolute;
  background: #fff;
  z-index: -1;
}
::ng-deep .introjs-tooltip:before {
  width: 135px;
  height: 135px;
  top: -67px;
  right: 37px;
  border-radius: 200px;
}
::ng-deep .introjs-tooltip:after {
  width: 75px;
  height: 75px;
  top: -37px;
  left: 37px;
  border-radius: 100px;
}
::ng-deep .introjs-tooltip .introjs-tooltiptext {
  text-align: center;
  padding: 0 15px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons {
  text-align: center;
  white-space: nowrap;
  margin-top: 10px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons a.introjs-button {
  padding: 9px 14px;
  border: none;
  border-radius: 4px;
  background: rgb(105, 190, 40);
  color: #fff;
  text-shadow: 0 0;
  margin: 0 0 0 5px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons a.introjs-button.introjs-disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.top-modal {
  display: inline-block;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.branding-details {
  text-align: left;
}

li.branding-profile {
  padding-bottom: 5px;
  padding-top: 3px;
}

.email-verification {
  text-align: center;
}

::ng-deep .owner-details .ibox-content .source-wrapper .image {
  display: inline-block;
}

@media screen and (max-width: 768px) {
  .dash-banner {
    flex-direction: column;
    text-align: center;
  }
  .dash-banner .dash-banner__icon {
    align-self: center;
  }
  .dash-banner .dash-banner__action {
    align-self: center;
  }
}
@media screen and (max-width: 575px) {
  .dash-greeting {
    font-size: 22px;
  }
}
.dash-card--profile-hz {
  border-top: 4px solid #ccc;
}
.dash-card--profile-hz.dash-card--profile-clarifier {
  border-top-color: rgb(0, 173, 208);
}
.dash-card--profile-hz.dash-card--profile-ideator {
  border-top-color: rgb(255, 121, 0);
}
.dash-card--profile-hz.dash-card--profile-developer {
  border-top-color: rgb(105, 190, 40);
}
.dash-card--profile-hz.dash-card--profile-implementer {
  border-top-color: rgb(245, 67, 89);
}
.dash-card--profile-hz.dash-card--profile-earlybird {
  border-top-color: rgb(0, 173, 208);
}
.dash-card--profile-hz.dash-card--profile-analyst {
  border-top-color: rgb(105, 190, 40);
}
.dash-card--profile-hz.dash-card--profile-driver {
  border-top-color: rgb(245, 67, 89);
}
.dash-card--profile-hz.dash-card--profile-finisher {
  border-top-color: rgb(245, 67, 89);
}
.dash-card--profile-hz.dash-card--profile-ideator-clarifier, .dash-card--profile-hz.dash-card--profile-clarifier-ideator {
  border-top-color: rgb(255, 121, 0);
}
.dash-card--profile-hz.dash-card--profile-developer-implementer, .dash-card--profile-hz.dash-card--profile-implementer-developer {
  border-top-color: rgb(105, 190, 40);
}
.dash-card--profile-hz.dash-card--profile-integrator {
  border-top-color: #a7a7a7;
}

.dash-profile-hz {
  display: flex;
}
@media screen and (max-width: 640px) {
  .dash-profile-hz {
    flex-direction: column;
  }
}
.dash-profile-hz__left {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 36px 32px;
  background: #f7f7f8;
}
@media screen and (max-width: 640px) {
  .dash-profile-hz__left {
    width: 100%;
    padding: 28px;
  }
}
.dash-profile-hz__left a {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.dash-profile-hz__left a:hover {
  transform: scale(1.03);
}
.dash-profile-hz__fs-logo {
  max-height: 56px;
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}
@media screen and (max-width: 640px) {
  .dash-profile-hz__fs-logo {
    max-height: 40px;
  }
}
.dash-profile-hz__right {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px 36px;
}
@media screen and (max-width: 640px) {
  .dash-profile-hz__right {
    width: 100%;
    padding: 24px;
  }
}
.dash-profile-hz__icon-wrap {
  margin-bottom: 14px;
}
.dash-profile-hz__icon-wrap ::ng-deep .profile-centered {
  width: 60px;
  height: 60px;
}
.dash-profile-hz__info {
  min-width: 0;
}
.dash-profile-hz__name {
  font-family: "Museo-700";
  font-size: 24px;
  margin: 0 0 4px;
  line-height: 1.3;
  color: #6d6e71;
}
.dash-profile-hz__title {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  color: #676a6c;
  display: block;
}
.dash-profile-hz__about {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #ccc;
  margin: 10px 0 0;
  line-height: 1.55;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.dash-profile-hz__view-link {
  display: inline-block;
  margin-top: 16px;
  font-size: 15px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.dash-profile-hz__view-link i {
  font-size: 12px;
  margin-left: 5px;
  transition: margin-left 0.15s ease;
}
.dash-profile-hz__view-link:hover {
  color: rgb(0, 173, 208);
}
.dash-profile-hz__view-link:hover i {
  margin-left: 10px;
}

.dash-card__lm-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #ccc;
  margin-bottom: 4px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.dash-card__lm-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  backdrop-filter: blur(4px);
  transition: all 0.2s ease;
}
.dash-card__lm-btn i {
  font-size: 11px;
}
.dash-card__lm-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.dash-branding-card {
  margin-top: 28px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e7eaec;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.dash-branding-card__accent {
  height: 3px;
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}
.dash-branding-card__inner {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 20px 24px;
}
@media screen and (max-width: 767px) {
  .dash-branding-card__inner {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
}
.dash-branding-card__logo {
  flex-shrink: 0;
}
.dash-branding-card__logo img {
  width: 140px;
  height: auto;
  opacity: 0.85;
}
.dash-branding-card__body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-width: 0;
}
@media screen and (max-width: 767px) {
  .dash-branding-card__body {
    flex-direction: column;
    gap: 14px;
  }
}
.dash-branding-card__identity {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dash-branding-card__profile-icon {
  flex-shrink: 0;
}
.dash-branding-card__profile-icon .profile_types {
  width: 34px;
  height: 15px;
  background-size: 175px 46px;
}
.dash-branding-card__no-profile {
  display: flex;
  align-items: center;
  gap: 3px;
}
.dash-branding-card__dot {
  display: block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  opacity: 0.35;
}
.dash-branding-card__dot--cl {
  background-color: rgb(0, 173, 208);
}
.dash-branding-card__dot--id {
  background-color: rgb(255, 121, 0);
}
.dash-branding-card__dot--dv {
  background-color: rgb(105, 190, 40);
}
.dash-branding-card__dot--im {
  background-color: rgb(245, 67, 89);
}
.dash-branding-card__details {
  min-width: 0;
}
.dash-branding-card__name {
  font-family: "Museo-700";
  font-size: 15px;
  margin: 0 0 2px;
  color: #6d6e71;
}
.dash-branding-card__type {
  font-size: 12px;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.dash-branding-card__contacts {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
@media screen and (max-width: 767px) {
  .dash-branding-card__contacts {
    justify-content: center;
  }
}
.dash-branding-card__contact {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 11px;
  font-weight: 500;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 5px;
  text-decoration: none;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.dash-branding-card__contact i {
  font-size: 11px;
  color: #ccc;
  width: 12px;
  text-align: center;
}
.dash-branding-card__contact:hover {
  border-color: rgb(0, 173, 208);
  color: rgb(0, 173, 208);
}
.dash-branding-card__contact:hover i {
  color: rgb(0, 173, 208);
}

.presenter__content p {
  font-size: 1.1em;
}

@media only screen and (max-width: 767px) {
  .dashcheck__colrow .fn-col {
    width: 100%;
  }
}

@media only screen and (max-width: 767px) {
  .presenter {
    padding-top: 0;
  }
  .presenter .fn-col {
    width: 100%;
  }
  .presenter a {
    word-break: break-all;
  }
  .presenter__address {
    max-width: 200px;
  }
  .presenter__broughtby {
    margin-top: 0;
  }
  .presenter__broughtby img {
    max-width: 100% !important;
    min-width: auto !important;
    width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/custom-profile/custom-dashboard/custom-dashboard.component.scss","webpack://./src/app/components/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;ACzYA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AD4YF;AC1YE;EALF;IAMI,0BAAA;ED6YF;AACF;AC1YE;EACE,WAAA;EACA,iBAAA;AD4YJ;ACxYE;;EAEE,iBAAA;AD0YJ;;ACtYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ADyYF;;ACrYA;EACE,gBAAA;ADwYF;ACtYE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;ADwYJ;ACtYI;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;ADwYN;;ACnYA;EACE,wBF9CS;EE+CT,eAAA;EACA,kBAAA;ADsYF;;ACnYA;EACE,wEFzDW;EE0DX,eAAA;EACA,cFxBmB;EEyBnB,SAAA;ADsYF;;AC/XA;EACE,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;EACA,qDAAA;ADkYF;AChYE;EACE,yCAAA;ADkYJ;;AC1XA;EACE,0BAAA;EACA,kBAAA;AD6XF;AC1XE;EAAiC,kCFpEnB;ACichB;AC5XE;EAA+B,kCFpElB;ACmcf;AC9XE;EAAiC,mCFpEnB;ACqchB;AChYE;EAAmC,kCFpEnB;ACuclB;AClYE;EAAiC,kCFxEnB;AC6chB;ACpYE;EAA+B,mCFvEjB;AC8chB;ACtYE;EAA8B,kCFvEd;ACgdlB;ACxYE;EAAgC,kCFxEhB;ACmdlB;AC1YE;EAAiF,kCF3EpE;ACwdf;AC5YE;EAAyF,mCF3E3E;AC0dhB;AC9YE;EAAkC,yBFlEhB;ACmdpB;AC/YE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;ADiZJ;AC9YE;EACE,cAAA;ADgZJ;AC9YI;EACE,cAAA;EACA,eAAA;ADgZN;AC7YI;EACE,WAAA;EACA,YAAA;AD+YN;AC3YE;EACE,YAAA;AD6YJ;AC1YE;EACE,wBF3HO;EE4HP,eAAA;EACA,eAAA;AD4YJ;ACzYE;EACE,wEFtIS;EEuIT,eAAA;EACA,cFrGiB;EEsGjB,cAAA;AD2YJ;ACxYE;EACE,oBAAA;AD0YJ;ACxYI;EACE,wEFhJO;EEiJP,eAAA;EACA,cF/Ge;EEgHf,gBAAA;EACA,SAAA;AD0YN;ACtYE;EACE,oBAAA;ADwYJ;ACrYE;EACE,wEF7JS;EE8JT,eAAA;EACA,cF5HiB;EE6HjB,qBAAA;EACA,eAAA;EACA,2BAAA;ADuYJ;ACrYI;EACE,gBAAA;EACA,eAAA;ADuYN;ACpYI;EACE,uBFrJU;AC2hBhB;;AC7XA;EACE,kBAAA;ADgYF;AC9XE;EACE,uBAAA;ADgYJ;AC9XI;EACE,gBAAA;EACA,YAAA;ADgYN;AC5XE;EACE,oBAAA;AD8XJ;AC3XE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AD6XJ;AC1XE;EACE,wBFrMO;EEsMP,eAAA;EACA,kBAAA;AD4XJ;ACzXE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AD2XJ;ACzXI;EACE,eAAA;EACA,cFtLe;ACijBrB;ACvXE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,cFjMiB;EEkMjB,WAAA;ADyXJ;ACvXI;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;ADyXN;ACtXI;EACE,cF5Me;EE6Mf,qBAAA;EACA,qBAAA;ADwXN;ACtXM;EACE,uBF/NQ;ACulBhB;;AC9WA;EACE,eAAA;EACA,gBAAA;ADiXF;AC/WE;EACE,2BAAA;EACA,0CAAA;ADiXJ;AC/WI;EACE,UAAA;ADiXN;AC7WE;EACE,uBAAA;AD+WJ;AC7WI;EACE,wBF1QK;EE2QL,eAAA;EACA,SAAA;AD+WN;AC3WE;EACE,kBAAA;AD6WJ;AC1WE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AD4WJ;ACzWE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,uBAAA;EACA,4DAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,6BAAA;AD2WJ;ACzWI;EACE,uBAAA;EACA,sBAAA;EACA,WAAA;AD2WN;;AClWA;EACE,kBAAA;EACA,kBAAA;ADqWF;ACnWE;EACE,eAAA;EACA,cF/QQ;EEgRR,mBAAA;ADqWJ;AClWE;EACE,eAAA;EACA,mBAAA;ADoWJ;ACjWE;EACE,wEFxUS;EEyUT,eAAA;EACA,cFvSiB;EEwSjB,gBAAA;EACA,kBAAA;EACA,gBAAA;ADmWJ;AChWE;EACE,cAAA;EACA,kBAAA;ADkWJ;;AC1VA;EACE,kBAAA;EACA,kBAAA;AD6VF;AC3VE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AD6VJ;AC1VE;EACE,wBFhWO;EEiWP,eAAA;EACA,mBAAA;AD4VJ;ACzVE;EACE,wEF3WS;EE4WT,eAAA;EACA,cF1UiB;EE2UjB,gBAAA;EACA,gBAAA;EACA,kBAAA;AD2VJ;ACzVI;EACE,uBF9VU;EE+VV,qBAAA;EACA,gBAAA;AD2VN;ACzVM;EACE,0BAAA;AD2VR;;ACjVA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;ADoVF;AClVE;EACE,mBAAA;EACA,qBAAA;ADoVJ;AClVI;EACE,cAAA;ADoVN;AChVE;EACE,mBAAA;EACA,qBAAA;ADkVJ;AChVI;EACE,uBFnYU;ACqtBhB;AC9UE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;ADgVJ;AC7UE;EACE,OAAA;AD+UJ;AC7UI;EACE,wBFjaK;EEkaL,eAAA;EACA,eAAA;AD+UN;AC5UI;EACE,wEF5aO;EE6aP,eAAA;EACA,cF3Ye;EE4Yf,SAAA;EACA,gBAAA;AD8UN;AC5UM;EACE,uBF9ZQ;EE+ZR,qBAAA;AD8UR;AC5UQ;EACE,0BAAA;AD8UV;ACxUE;EACE,cAAA;EACA,kBAAA;AD0UJ;ACxUI;EACE,mBAAA;EACA,eAAA;AD0UN;;AChUE;;EAEE,2EAAA;EACA,sBAAA;EACA,4CAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;ADmUJ;AChUE;EACE,2EAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EACA,UAAA;ADkUJ;AC/TE;EACE,2EAAA;EACA,sBAAA;EACA,4CAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;ADiUJ;;AC7TA;EACE;IACE,0BAAA;EDgUF;EC9TA;IACE,0BAAA;EDgUF;AACF;ACzTA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;EACA,YAAA;EACA,YAAA;EACA,gBFxbiB;EEybjB,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;AD2TF;ACzTE;EACE,qFAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,gCAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;AD2TJ;ACxTE;EACE,qFAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,gCAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AD0TJ;ACvTE;EAEE,WAAA;EACA,kBAAA;EACA,gBF7de;EE8df,WAAA;ADwTJ;ACrTE;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;ADuTJ;ACpTE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;ADsTJ;ACnTE;EACE,kBAAA;EACA,eAAA;ADqTJ;AClTE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;ADoTJ;AClTI;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BF/iBU;EEgjBV,WFhgBa;EEigBb,gBAAA;EACA,iBAAA;ADoTN;AClTM;EACE,YAAA;EACA,mBAAA;ADoTR;;AC1SA;EACE,qBAAA;AD6SF;;AC1SA;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AD6SF;;AC1SA;;;EAGE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AD6SF;;AC1SA;EACE,gBAAA;AD6SF;;AC1SA;EACE,mBAAA;EACA,gBAAA;AD6SF;;AC1SA;EACE,kBAAA;AD6SF;;ACvSM;EACE,qBAAA;AD0SR;;AChSA;EACE;IACE,sBAAA;IACA,kBAAA;EDmSF;ECjSE;IACE,kBAAA;EDmSJ;EChSE;IACE,kBAAA;EDkSJ;AACF;AC9RA;EACE;IACE,eAAA;EDgSF;AACF;ACzRA;EACE,0BAAA;AD2RF;ACzRE;EAAiC,kCF/oBnB;AC26BhB;AC3RE;EAA+B,kCF/oBlB;AC66Bf;AC7RE;EAAiC,mCF/oBnB;AC+6BhB;AC/RE;EAAmC,kCF/oBnB;ACi7BlB;ACjSE;EAAiC,kCFnpBnB;ACu7BhB;ACnSE;EAA+B,mCFlpBjB;ACw7BhB;ACrSE;EAA8B,kCFlpBd;AC07BlB;ACvSE;EAAgC,kCFnpBhB;AC67BlB;ACzSE;EAAiF,kCFtpBpE;ACk8Bf;AC3SE;EAAyF,mCFtpB3E;ACo8BhB;AC7SE;EAAkC,yBF7oBhB;AC67BpB;;AC7SA;EACE,aAAA;ADgTF;AC9SE;EAHF;IAII,sBAAA;EDiTF;AACF;AC9SE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;ADgTJ;AC9SI;EARF;IASI,WAAA;IACA,aAAA;EDiTJ;AACF;AC/SI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,+BAAA;ADiTN;AC/SM;EAAU,sBAAA;ADkThB;AC9SE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ADgTJ;AC9SI;EAPF;IAQI,gBAAA;EDiTJ;AACF;AC7SE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AD+SJ;AC7SI;EAPF;IAQI,WAAA;IACA,aAAA;EDgTJ;AACF;AC7SE;EACE,mBAAA;AD+SJ;AC7SI;EACE,WAAA;EACA,YAAA;AD+SN;AC3SE;EACE,YAAA;AD6SJ;AC1SE;EACE,wBFpvBO;EEqvBP,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cFrtBiB;ACigCrB;ACzSE;EACE,wEFjwBS;EEkwBT,eAAA;EACA,cFhuBiB;EEiuBjB,cAAA;AD2SJ;ACxSE;EACE,wEFxwBS;EEywBT,eAAA;EACA,WFhuBgB;EEiuBhB,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AD0SJ;ACvSE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEFxxBS;EEyxBT,cFtvBiB;EEuvBjB,qBAAA;EACA,4BAAA;ADySJ;ACvSI;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;ADySN;ACtSI;EACE,uBF/wBU;ACujChB;ACvSM;EAAI,iBAAA;AD0SV;;ACjSA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WFzwBkB;EE0wBlB,kBAAA;EACA,wEFrzBW;ACylCb;;ACjSA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEF/zBW;EEg0BX,WAAA;EACA,qCAAA;EACA,0CAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;ADoSF;AClSE;EAAI,eAAA;ADqSN;ACnSE;EACE,oCAAA;ADqSJ;;AC7RA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yCAAA;ADgSF;AC9RE;EACE,WAAA;EACA,oNAAA;ADgSJ;ACvRE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;ADyRJ;ACvRI;EANF;IAOI,sBAAA;IACA,kBAAA;IACA,SAAA;ED0RJ;AACF;ACvRE;EACE,cAAA;ADyRJ;ACvRI;EACE,YAAA;EACA,YAAA;EACA,aAAA;ADyRN;ACrRE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;ADuRJ;ACrRI;EARF;IASI,sBAAA;IACA,SAAA;EDwRJ;AACF;ACrRE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ADuRJ;ACpRE;EACE,cAAA;ADsRJ;ACpRI;EACE,WAAA;EACA,YAAA;EACA,2BAAA;ADsRN;AClRE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ADoRJ;ACjRE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;ADmRJ;ACjRI;EAAQ,kCFl5BI;ACsqChB;ACnRI;EAAQ,kCFl5BG;ACwqCf;ACrRI;EAAQ,mCFl5BI;AC0qChB;ACvRI;EAAQ,kCFl5BM;AC4qClB;ACvRE;EACE,YAAA;ADyRJ;ACtRE;EACE,wBF76BO;EE86BP,eAAA;EACA,eAAA;EACA,cF74BiB;ACqqCrB;ACrRE;EACE,eAAA;EACA,cFv5BiB;EEw5BjB,wEF37BS;ACktCb;ACpRE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;ADsRJ;ACpRI;EANF;IAOI,uBAAA;EDuRJ;AACF;ACpRE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEFh9BS;EEi9BT,cF96BiB;EE+6BjB,mBFv6BkB;EEw6BlB,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,0BAAA;EACA,mBAAA;ADsRJ;ACpRI;EACE,eAAA;EACA,WFj7Bc;EEk7Bd,WAAA;EACA,kBAAA;ADsRN;ACnRI;EACE,8BF58BU;EE68BV,uBF78BU;ACkuChB;ACnRM;EAAI,uBF/8BM;ACquChB;;AAzvCA;EACE,gBAAA;AA4vCF;;AAtvCE;EAEE;IACE,WAAA;EAwvCJ;AACF;;AAnvCE;EADF;IAEI,cAAA;EAuvCF;EArvCE;IACE,WAAA;EAuvCJ;EApvCE;IACE,qBAAA;EAsvCJ;EAnvCE;IACE,gBAAA;EAqvCJ;EAlvCE;IAEE,aAAA;EAmvCJ;EAjvCI;IACE,0BAAA;IACA,0BAAA;IACA,YAAA;EAmvCN;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../app/components/dashboard/dashboard.component.scss';\n\n.presenter__content p {\n  font-size: 1.1em;\n}\n\n\n.dashcheck__colrow {\n\n  @media #{$mobile} {\n\n    .fn-col {\n      width: 100%;\n    }\n  }\n}\n\n.presenter {\n  @media #{$mobile} {\n    padding-top: 0;\n\n    .fn-col {\n      width: 100%;\n    }\n\n    a {\n      word-break: break-all;\n    }\n\n    &__address {\n      max-width: 200px;\n    }\n\n    &__broughtby {\n\n      margin-top: 0;\n\n      img {\n        max-width: 100% !important;\n        min-width: auto !important;\n        width: 200px;\n      }\n    }\n  }\n}","@import './../../../assets/styles/variables';\n\n// ==========================================\n// Dashboard Layout & Grid\n// ==========================================\n\n.dash-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n\n  @media screen and (max-width: 991px) {\n    grid-template-columns: 1fr;\n  }\n\n  // Override f-col width system inside grid — grid handles sizing\n  & > [class*=\"f-col-\"] {\n    width: 100%;\n    padding-inline: 0;\n  }\n\n  // Full-width items span both columns\n  .f-col-12,\n  .dash-banner {\n    grid-column: 1 / -1;\n  }\n}\n\n.dash-left-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n// LM cell stretches and scrolls if taller than left\n.dash-lm-cell {\n  overflow: hidden;\n\n  .dash-card--learnermap {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .dash-card__lm-image {\n      flex: 1;\n      overflow-y: auto;\n      overflow-x: auto;\n    }\n  }\n}\n\n.dash-greeting {\n  font-family: $muso-700;\n  font-size: 26px;\n  margin-bottom: 2px;\n}\n\n.dash-subtitle {\n  font-family: $font-stack;\n  font-size: 14px;\n  color: $body-content-color;\n  margin: 0;\n}\n\n// ==========================================\n// Dashboard Card Base\n// ==========================================\n\n.dash-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #eef0f2;\n  overflow: hidden;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n}\n\n// ==========================================\n// Profile Card (centered)\n// ==========================================\n\n.dash-card--profile {\n  border-top: 4px solid $color-neutral-mid;\n  text-align: center;\n\n  // Profile-type accent colors\n  &.dash-card--profile-clarifier { border-top-color: $clarify-color; }\n  &.dash-card--profile-ideator { border-top-color: $ideate-color; }\n  &.dash-card--profile-developer { border-top-color: $develop-color; }\n  &.dash-card--profile-implementer { border-top-color: $implement-color; }\n  &.dash-card--profile-earlybird { border-top-color: $clarify-color; }\n  &.dash-card--profile-analyst { border-top-color: $develop-color; }\n  &.dash-card--profile-driver { border-top-color: $implement-color; }\n  &.dash-card--profile-finisher { border-top-color: $implement-color; }\n  &.dash-card--profile-ideator-clarifier, &.dash-card--profile-clarifier-ideator { border-top-color: $ideate-color; }\n  &.dash-card--profile-developer-implementer, &.dash-card--profile-implementer-developer { border-top-color: $develop-color; }\n  &.dash-card--profile-integrator { border-top-color: $report-integrator; }\n\n  .dash-card__profile-header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 24px 24px 16px;\n  }\n\n  .dash-card__profile-avatar {\n    flex-shrink: 0;\n\n    a {\n      display: block;\n      cursor: pointer;\n    }\n\n    ::ng-deep .profile-centered {\n      width: 72px;\n      height: 72px;\n    }\n  }\n\n  .dash-card__profile-info {\n    min-width: 0;\n  }\n\n  .dash-card__profile-name {\n    font-family: $muso-700;\n    font-size: 20px;\n    margin: 0 0 4px;\n  }\n\n  .dash-card__profile-title {\n    font-family: $font-stack;\n    font-size: 14px;\n    color: $body-content-color;\n    display: block;\n  }\n\n  .dash-card__profile-body {\n    padding: 0 24px 16px;\n\n    p {\n      font-family: $font-stack;\n      font-size: 14px;\n      color: $body-content-color;\n      line-height: 1.6;\n      margin: 0;\n    }\n  }\n\n  .dash-card__profile-footer {\n    padding: 0 24px 24px;\n  }\n\n  .dash-card__view-link {\n    font-family: $font-stack;\n    font-size: 13px;\n    color: $body-content-color;\n    text-decoration: none;\n    cursor: pointer;\n    transition: color 0.2s ease;\n\n    i {\n      margin-left: 4px;\n      font-size: 11px;\n    }\n\n    &:hover {\n      color: $clarify-color;\n    }\n  }\n}\n\n// ==========================================\n// Branding / Source Owner Card (centered)\n// ==========================================\n\n.dash-card--branding {\n  text-align: center;\n\n  .dash-card__branding-header {\n    padding: 24px 24px 16px;\n\n    .dash-card__branding-logo {\n      max-width: 200px;\n      height: auto;\n    }\n  }\n\n  .dash-card__branding-body {\n    padding: 0 24px 24px;\n  }\n\n  .dash-card__contact-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  .dash-card__contact-name {\n    font-family: $muso-700;\n    font-size: 16px;\n    margin-bottom: 4px;\n  }\n\n  .dash-card__contact-profile {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #eef0f2;\n\n    span {\n      font-size: 13px;\n      color: $body-content-color;\n    }\n  }\n\n  .dash-card__contact-item {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 4px 0;\n    font-size: 13px;\n    color: $body-content-color;\n    width: 100%;\n\n    i {\n      width: 16px;\n      text-align: center;\n      color: #9ca3af;\n      flex-shrink: 0;\n    }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      word-break: break-all;\n\n      &:hover {\n        color: $clarify-color;\n      }\n    }\n  }\n}\n\n// ==========================================\n// Learner Map Card (no crop)\n// ==========================================\n\n.dash-card--learnermap {\n  cursor: pointer;\n  overflow: hidden;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n\n    .dash-card__lm-overlay {\n      opacity: 1;\n    }\n  }\n\n  .dash-card__lm-header {\n    padding: 20px 24px 12px;\n\n    h5 {\n      font-family: $muso-700;\n      font-size: 16px;\n      margin: 0;\n    }\n  }\n\n  .dash-card__lm-image {\n    position: relative;\n  }\n\n  .dash-card__lm-img {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    display: block;\n  }\n\n  .dash-card__lm-overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 40px 24px 24px;\n    background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));\n    display: flex;\n    justify-content: center;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n\n    .f-btn--outline {\n      background: transparent;\n      border: 1px solid #fff;\n      color: #fff;\n    }\n  }\n}\n\n// ==========================================\n// Error State Card\n// ==========================================\n\n.dash-card--error {\n  text-align: center;\n  padding: 48px 32px;\n\n  .dash-error-icon {\n    font-size: 48px;\n    color: $color-red;\n    margin-bottom: 16px;\n  }\n\n  h2 {\n    font-size: 22px;\n    margin-bottom: 12px;\n  }\n\n  p {\n    font-family: $font-stack;\n    font-size: 14px;\n    color: $body-content-color;\n    max-width: 480px;\n    margin: 0 auto 8px;\n    line-height: 1.6;\n  }\n\n  .dash-error-hint {\n    color: #9ca3af;\n    font-style: italic;\n  }\n}\n\n// ==========================================\n// Empty / Missing Profile State\n// ==========================================\n\n.dash-card--empty {\n  text-align: center;\n  padding: 40px 32px;\n\n  .dash-empty-icon {\n    font-size: 48px;\n    color: #d1d5db;\n    margin-bottom: 16px;\n  }\n\n  h5 {\n    font-family: $muso-700;\n    font-size: 18px;\n    margin-bottom: 12px;\n  }\n\n  p {\n    font-family: $font-stack;\n    font-size: 14px;\n    color: $body-content-color;\n    line-height: 1.6;\n    max-width: 420px;\n    margin: 0 auto 8px;\n\n    a {\n      color: $clarify-color;\n      text-decoration: none;\n      font-weight: 600;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n// ==========================================\n// Alert Banners (Email Verification / Password)\n// ==========================================\n\n.dash-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 20px 24px;\n  border-radius: 12px;\n  border: 1px solid;\n\n  &--warning {\n    background: #fffbeb;\n    border-color: #fde68a;\n\n    .dash-banner__icon {\n      color: #f59e0b;\n    }\n  }\n\n  &--info {\n    background: #eff6ff;\n    border-color: #bfdbfe;\n\n    .dash-banner__icon {\n      color: $clarify-color;\n    }\n  }\n\n  .dash-banner__icon {\n    font-size: 22px;\n    flex-shrink: 0;\n    padding-top: 2px;\n  }\n\n  .dash-banner__content {\n    flex: 1;\n\n    h5 {\n      font-family: $muso-700;\n      font-size: 15px;\n      margin: 0 0 6px;\n    }\n\n    p {\n      font-family: $font-stack;\n      font-size: 13px;\n      color: $body-content-color;\n      margin: 0;\n      line-height: 1.5;\n\n      a {\n        color: $clarify-color;\n        text-decoration: none;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  .dash-banner__action {\n    flex-shrink: 0;\n    align-self: center;\n\n    .f-btn {\n      white-space: nowrap;\n      cursor: pointer;\n    }\n  }\n}\n\n// ==========================================\n// Loading Shimmer (keep existing for Pace.js compat)\n// ==========================================\n\n::ng-deep .pace-running:not(.pace-done) {\n  .dash-card__profile-name,\n  .dash-card__profile-title {\n    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n    background-size: 600px;\n    animation: shine-avatar 1.6s infinite linear;\n    height: 20px;\n    font-size: 0;\n    border-radius: 4px;\n  }\n\n  .dash-card__branding-logo {\n    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n    background-size: 600px;\n    animation: shine-avatar 1.6s infinite linear;\n    height: 100px;\n    opacity: 0;\n  }\n\n  .dash-card__contact-list li {\n    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n    background-size: 600px;\n    animation: shine-avatar 1.6s infinite linear;\n    margin: 0 0 1px 0;\n    height: 19px;\n    font-size: 0;\n    border-radius: 4px;\n  }\n}\n\n@keyframes shine-avatar {\n  0% {\n    background-position: -32px;\n  }\n  40%, 100% {\n    background-position: 500px;\n  }\n}\n\n// ==========================================\n// Intro.js Tooltip (kept for onboarding)\n// ==========================================\n\n::ng-deep .introjs-tooltip {\n  box-sizing: content-box;\n  visibility: visible;\n  min-width: 200px;\n  max-width: 300px;\n  transition: opacity .1s ease-out;\n  width: 243px;\n  height: auto;\n  background: $color-light-type;\n  border-radius: 100px;\n  position: relative;\n  margin: 90px auto 20px;\n  padding: 20px !important;\n  box-shadow: 0 0px !important;\n\n  .introjs-arrow.top {\n    background: url($assets+'/images/cloud-arrow-icon.png');\n    width: 10px !important;\n    height: 10px !important;\n    display: block !important;\n    padding: 32px;\n    background-size: 100% !important;\n    top: -80px;\n    background-color: transparent;\n    border: none;\n  }\n\n  .introjs-arrow.left {\n    background: url($assets+'/images/cloud-arrow-icon.png');\n    width: 10px !important;\n    height: 10px !important;\n    display: block !important;\n    padding: 32px;\n    background-size: 100% !important;\n    top: 90px;\n    background-color: transparent;\n    border: none;\n    transform: rotate(-70deg);\n    left: -50px;\n  }\n\n  &:after,\n  &:before {\n    content: '';\n    position: absolute;\n    background: $color-light-type;\n    z-index: -1;\n  }\n\n  &:before {\n    width: 135px;\n    height: 135px;\n    top: -67px;\n    right: 37px;\n    border-radius: 200px;\n  }\n\n  &:after {\n    width: 75px;\n    height: 75px;\n    top: -37px;\n    left: 37px;\n    border-radius: 100px;\n  }\n\n  .introjs-tooltiptext {\n    text-align: center;\n    padding: 0 15px;\n  }\n\n  .introjs-tooltipbuttons {\n    text-align: center;\n    white-space: nowrap;\n    margin-top: 10px;\n\n    a.introjs-button {\n      padding: 9px 14px;\n      border: none;\n      border-radius: 4px;\n      background: $develop-color;\n      color: $color-light-type;\n      text-shadow: 0 0;\n      margin: 0 0 0 5px;\n\n      &.introjs-disabled {\n        opacity: .8;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n// ==========================================\n// Legacy compat (for modal, video, etc.)\n// ==========================================\n\n.top-modal {\n  display: inline-block;\n}\n\n.video-container {\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n  overflow: hidden;\n}\n\n.video-container iframe,\n.video-container object,\n.video-container embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.branding-details {\n  text-align: left;\n}\n\nli.branding-profile {\n  padding-bottom: 5px;\n  padding-top: 3px;\n}\n\n.email-verification {\n  text-align: center;\n}\n\n::ng-deep .owner-details {\n  .ibox-content {\n    .source-wrapper {\n      .image {\n        display: inline-block;\n      }\n    }\n  }\n}\n\n// ==========================================\n// Responsive\n// ==========================================\n\n@media screen and (max-width: 768px) {\n  .dash-banner {\n    flex-direction: column;\n    text-align: center;\n\n    .dash-banner__icon {\n      align-self: center;\n    }\n\n    .dash-banner__action {\n      align-self: center;\n    }\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .dash-greeting {\n    font-size: 22px;\n  }\n}\n\n// ==========================================\n// Profile Card — Horizontal (logo left, info right)\n// ==========================================\n\n.dash-card--profile-hz {\n  border-top: 4px solid $color-neutral-mid;\n\n  &.dash-card--profile-clarifier { border-top-color: $clarify-color; }\n  &.dash-card--profile-ideator { border-top-color: $ideate-color; }\n  &.dash-card--profile-developer { border-top-color: $develop-color; }\n  &.dash-card--profile-implementer { border-top-color: $implement-color; }\n  &.dash-card--profile-earlybird { border-top-color: $clarify-color; }\n  &.dash-card--profile-analyst { border-top-color: $develop-color; }\n  &.dash-card--profile-driver { border-top-color: $implement-color; }\n  &.dash-card--profile-finisher { border-top-color: $implement-color; }\n  &.dash-card--profile-ideator-clarifier, &.dash-card--profile-clarifier-ideator { border-top-color: $ideate-color; }\n  &.dash-card--profile-developer-implementer, &.dash-card--profile-implementer-developer { border-top-color: $develop-color; }\n  &.dash-card--profile-integrator { border-top-color: $report-integrator; }\n}\n\n.dash-profile-hz {\n  display: flex;\n\n  @media screen and (max-width: 640px) {\n    flex-direction: column;\n  }\n\n  // ── Left: FourSight logo ──\n  &__left {\n    width: 40%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 36px 32px;\n    background: #f7f7f8;\n\n    @media screen and (max-width: 640px) {\n      width: 100%;\n      padding: 28px;\n    }\n\n    a {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      transition: transform 0.2s ease;\n\n      &:hover { transform: scale(1.03); }\n    }\n  }\n\n  &__fs-logo {\n    max-height: 56px;\n    max-width: 100%;\n    width: auto;\n    height: auto;\n    object-fit: contain;\n\n    @media screen and (max-width: 640px) {\n      max-height: 40px;\n    }\n  }\n\n  // ── Right: Profile info ──\n  &__right {\n    width: 60%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 32px 36px;\n\n    @media screen and (max-width: 640px) {\n      width: 100%;\n      padding: 24px;\n    }\n  }\n\n  &__icon-wrap {\n    margin-bottom: 14px;\n\n    ::ng-deep .profile-centered {\n      width: 60px;\n      height: 60px;\n    }\n  }\n\n  &__info {\n    min-width: 0;\n  }\n\n  &__name {\n    font-family: $muso-700;\n    font-size: 24px;\n    margin: 0 0 4px;\n    line-height: 1.3;\n    color: $color-neutral-dark;\n  }\n\n  &__title {\n    font-family: $font-stack;\n    font-size: 16px;\n    color: $body-content-color;\n    display: block;\n  }\n\n  &__about {\n    font-family: $font-stack;\n    font-size: 14px;\n    color: $color-neutral-mid;\n    margin: 10px 0 0;\n    line-height: 1.55;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  &__view-link {\n    display: inline-block;\n    margin-top: 16px;\n    font-size: 15px;\n    font-weight: 600;\n    font-family: $font-stack;\n    color: $body-content-color;\n    text-decoration: none;\n    transition: color 0.15s ease;\n\n    i {\n      font-size: 12px;\n      margin-left: 5px;\n      transition: margin-left 0.15s ease;\n    }\n\n    &:hover {\n      color: $clarify-color;\n      i { margin-left: 10px; }\n    }\n  }\n}\n\n// ==========================================\n// Learner Map Card — Updated\n// ==========================================\n\n.dash-card__lm-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: $color-neutral-mid;\n  margin-bottom: 4px;\n  font-family: $font-stack;\n}\n\n.dash-card__lm-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-radius: 6px;\n  backdrop-filter: blur(4px);\n  transition: all 0.2s ease;\n\n  i { font-size: 11px; }\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n}\n\n// ==========================================\n// Branding Card — bottom of dashboard\n// ==========================================\n\n.dash-branding-card {\n  margin-top: 28px;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n\n  &__accent {\n    height: 3px;\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%, $clarify-color 25%,\n      $ideate-color 25%, $ideate-color 50%,\n      $develop-color 50%, $develop-color 75%,\n      $implement-color 75%, $implement-color 100%\n    );\n  }\n\n  &__inner {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    padding: 20px 24px;\n\n    @media screen and (max-width: 767px) {\n      flex-direction: column;\n      text-align: center;\n      gap: 16px;\n    }\n  }\n\n  &__logo {\n    flex-shrink: 0;\n\n    img {\n      width: 140px;\n      height: auto;\n      opacity: 0.85;\n    }\n  }\n\n  &__body {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    min-width: 0;\n\n    @media screen and (max-width: 767px) {\n      flex-direction: column;\n      gap: 14px;\n    }\n  }\n\n  &__identity {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__profile-icon {\n    flex-shrink: 0;\n\n    .profile_types {\n      width: 34px;\n      height: 15px;\n      background-size: 175px 46px;\n    }\n  }\n\n  &__no-profile {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n  }\n\n  &__dot {\n    display: block;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    opacity: 0.35;\n\n    &--cl { background-color: $clarify-color; }\n    &--id { background-color: $ideate-color; }\n    &--dv { background-color: $develop-color; }\n    &--im { background-color: $implement-color; }\n  }\n\n  &__details {\n    min-width: 0;\n  }\n\n  &__name {\n    font-family: $muso-700;\n    font-size: 15px;\n    margin: 0 0 2px;\n    color: $color-neutral-dark;\n  }\n\n  &__type {\n    font-size: 12px;\n    color: $body-content-color;\n    font-family: $font-stack;\n  }\n\n  &__contacts {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n\n    @media screen and (max-width: 767px) {\n      justify-content: center;\n    }\n  }\n\n  &__contact {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 5px 12px;\n    font-size: 11px;\n    font-weight: 500;\n    font-family: $font-stack;\n    color: $body-content-color;\n    background: $color-neutral-light;\n    border: 1px solid $color-grey-1;\n    border-radius: 5px;\n    text-decoration: none;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n\n    i {\n      font-size: 11px;\n      color: $color-neutral-mid;\n      width: 12px;\n      text-align: center;\n    }\n\n    &:hover {\n      border-color: $clarify-color;\n      color: $clarify-color;\n\n      i { color: $clarify-color; }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
